import { css, createGlobalStyle } from 'styled-components';
import React from 'react';

import CircularBookEOT from './assets/circular/LL-Circular-Book-Web/fonts_subsetted/lineto-circular-book.eot';
import CircularBookWOFF from './assets/circular/LL-Circular-Book-Web/fonts_subsetted/lineto-circular-book.woff';
import CircularBookWOFF2 from './assets/circular/LL-Circular-Book-Web/fonts_subsetted/lineto-circular-book.woff2';
import CircularMediumEOT from './assets/circular/LL-Circular-Medium-Web/fonts_subsetted/lineto-circular-medium.eot';
import CircularMediumWOFF from './assets/circular/LL-Circular-Medium-Web/fonts_subsetted/lineto-circular-medium.woff';
import CircularMediumWOFF2 from './assets/circular/LL-Circular-Medium-Web/fonts_subsetted/lineto-circular-medium.woff2';
import CircularStdBook from './assets/circular/CircularStd/CircularStd-Book.otf';
import CircularStdMedium from './assets/circular/CircularStd/CircularStd-Medium.otf';
import CircularStdBlack from './assets/circular/CircularStd/CircularStd-Black.otf';
import CircularStdBold from './assets/circular/CircularStd/CircularStd-Bold.otf';
import InterRegularEOT from './assets/inter/fonts/regular_subset/inter-v3-latin-regular.eot';
import InterRegularWOFF from './assets/inter/fonts/regular_subset/inter-v3-latin-regular.woff';
import InterRegularWOFF2 from './assets/inter/fonts/regular_subset/inter-v3-latin-regular.woff2';
import InterMediumEOT from './assets/inter/fonts/medium_subset/inter-v3-latin-500.eot';
import InterMediumWOFF from './assets/inter/fonts/medium_subset/inter-v3-latin-500.woff';
import InterMediumWOFF2 from './assets/inter/fonts/medium_subset/inter-v3-latin-500.woff2';
import InterSemiBoldEOT from './assets/inter/fonts/semi-bold_subset/inter-v3-latin-600.eot';
import InterSemiBoldWOFF from './assets/inter/fonts/semi-bold_subset/inter-v3-latin-600.woff';
import InterSemiBoldWOFF2 from './assets/inter/fonts/semi-bold_subset/inter-v3-latin-600.woff2';
import SignatureFont from './assets/Otella.ttf';
import IconsEOT from './assets/icons/jerry-mini.eot';
import IconsTTF from './assets/icons/jerry-mini.ttf';
import IconsWOFF from './assets/icons/jerry-mini.woff';
import IconsWOFF2 from './assets/icons/jerry-mini.woff2';
import LyftProUIBold from './assets/lyft/LyftProUI-Bold.otf';
import ProximaNovaBold from './assets/proximanova/ProximaNova-Bold.otf';
import ProximaNovaRegular from './assets/proximanova/ProximaNova-Regular.otf';
import { FontNames } from './const.FontsCSS';

/**
 * Font styles
 */
export const FontStyles = {
  circular: css`
    @font-face {
      font-family: '${FontNames.circular}';
      font-weight: normal;
      src: url(${CircularBookEOT}) format('embedded-opentype'), url(${CircularBookWOFF2}) format('woff2'),
        url(${CircularBookWOFF}) format('woff');
      font-display: swap;
    }
    @font-face {
      font-family: '${FontNames.circular}';
      font-weight: 500;
      src: url(${CircularMediumEOT}) format('embedded-opentype'), url(${CircularMediumWOFF2}) format('woff2'),
        url(${CircularMediumWOFF}) format('woff');
      font-display: swap;
    }
  `,
  cricularStd: css`
    @font-face {
      font-family: '${FontNames.circularStd}';
      font-weight: 400; /* normal */
      src: url(${CircularStdBook}) format('opentype');
    }
    @font-face {
      font-family: '${FontNames.circularStd}';
      font-weight: 500;
      src: url(${CircularStdMedium}) format('opentype');
    }
    @font-face {
      font-family: '${FontNames.circularStd}';
      font-weight: 700;
      src: url(${CircularStdBold}) format('opentype');
    }
    @font-face {
      font-family: '${FontNames.circularStd}';
      font-weight: 900;
      src: url(${CircularStdBlack}) format('opentype');
    }
  `,
  circularFallback: css`
    @font-face {
      font-family: ${FontNames.circularFallback};
      size-adjust: 101.37%;
      ascent-override: 95%;
      src: local('Arial');
    }

    @font-face {
      font-family: '${FontNames.circularFallback}';
      font-weight: 500;
      size-adjust: 103.31%;
      ascent-override: 93%;
      src: local('Arial');
    }
  `,
  inter: css`
    @font-face {
      font-family: '${FontNames.inter}';
      font-weight: normal;
      src: url(${InterRegularEOT}) format('embedded-opentype'), url(${InterRegularWOFF2}) format('woff2'),
        url(${InterRegularWOFF}) format('woff');
      font-display: swap;
    }
    @font-face {
      font-family: '${FontNames.inter}';
      font-weight: 500;
      src: url(${InterMediumEOT}) format('embedded-opentype'), url(${InterMediumWOFF2}) format('woff2'),
        url(${InterMediumWOFF}) format('woff');
      font-display: swap;
    }
    @font-face {
      font-family: '${FontNames.inter}';
      font-weight: 600;
      src: url(${InterSemiBoldEOT}) format('embedded-opentype'), url(${InterSemiBoldWOFF2}) format('woff2'),
        url(${InterSemiBoldWOFF}) format('woff');
      font-display: swap;
    }
  `,
  interFallback: css`
    @font-face {
      font-family: ${FontNames.interFallback};
      size-adjust: 107%;
      ascent-override: 90%;
      src: local('Arial');
    }

    @font-face {
      font-family: '${FontNames.interFallback}';
      font-weight: 500;
      size-adjust: 108.19%;
      ascent-override: 84%;
      src: local('Arial');
    }

    @font-face {
      font-family: '${FontNames.interFallback}';
      font-weight: 600;
      size-adjust: 109.25%;
      ascent-override: 83%;
      src: local('Arial');
    }
  `,
  signature: css`
    @font-face {
      font-family: '${FontNames.signature}';
      font-family: 'Signature';
      src: url(${SignatureFont});
      font-display: swap;
    }
  `,
  icons: css`
    @font-face {
      font-family: '${FontNames.icons}';
      src: url(${IconsEOT}) format('embedded-opentype'), url(${IconsWOFF2}) format('woff2'),
        url(${IconsWOFF}) format('woff'), url(${IconsTTF}) format('truetype');
      font-weight: normal;
      font-style: normal;
      font-display: swap;
    }
  `,
  lyftProUiBold: css`
    @font-face {
      font-family: '${FontNames.lyft}';
      font-weight: 500;
      src: url(${LyftProUIBold}) format('opentype');
      font-display: swap;
    }
  `,
  proximaNovaBold: css`
    @font-face {
      font-family: '${FontNames.lyft}';
      font-weight: 450;
      src: url(${ProximaNovaBold}) format('opentype');
      font-display: swap;
    }
  `,
  proximaNovaRegular: css`
    @font-face {
      font-family: '${FontNames.lyft}';
      font-weight: 400;
      src: url(${ProximaNovaRegular}) format('opentype');
      font-display: swap;
    }
  `,
};

/**
 * Global font style component
 * Must be included in web application before using values from `FontNames`
 */
export const FontsCSS = createGlobalStyle`
  ${FontStyles.circular}
  ${FontStyles.circularFallback}
  ${FontStyles.cricularStd}
  ${FontStyles.inter}
  ${FontStyles.interFallback}
  ${FontStyles.signature}
  ${FontStyles.icons}
  ${FontStyles.lyftProUiBold}
  ${FontStyles.proximaNovaBold}
  ${FontStyles.proximaNovaRegular}
`;

/**
 * preload fonts to avoid critical request chain
 * only preload woff2 fonts considering the balance of waste of preload data and modern browser support
 */
export const FontsPreloader = (
  <>
    <link rel="preload" href={CircularBookWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={CircularMediumWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={InterRegularWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={InterMediumWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={InterSemiBoldWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
    <link rel="preload" href={IconsWOFF2} as="font" type="font/woff2" crossOrigin="anonymous" />
  </>
);
